import { get } from 'lodash';
import { createSelector } from 'reselect';

const allIdsSelector = state => get( state, 'domainNotes.allIds', [] );
export const domainNotesByIdSelector = state => get( state, 'domainNotes.byId', {} );
export const domainNotesIsLoadingSelector = state => get( state, 'domainNotes.isLoading', false );
export const domainNotesErrorMessage = state => get( state, 'domainNotes.errorMessage', '' );

export const domainNotesSelector = createSelector(
    allIdsSelector,
    domainNotesByIdSelector,
    ( noteIds, notesMap ) => noteIds.map( id => notesMap[id] )
);
